import {getApiUrl} from "./client";
import {HOTSPOT_HABITAT_FEEDBACK_SUMMARY_ENDPOINT} from "./constants";
import type {HotspotHabitatFeedbackSummary} from "../helpers/types";

export type HotspotHabitatFeedbackSummaryResponse = {
    status: string;
    summariesByLocationId: Record<string, HotspotHabitatFeedbackSummary>;
};

export const getHotspotHabitatFeedbackSummary = async (locationIds: string[]) => {
    const response = await fetch(getApiUrl(HOTSPOT_HABITAT_FEEDBACK_SUMMARY_ENDPOINT), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({locationIds})
    });

    if (!response.ok) {
        let message = `Habitat feedback summary request failed with ${response.status}`;

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Ignore parse errors and surface the HTTP status instead.
        }

        throw new Error(message);
    }

    return await response.json() as HotspotHabitatFeedbackSummaryResponse;
};
